const FULLY_PAID_STATUSES = [
  "Payment done,Awaiting for Bills",
  "Bills Quality Hold",
  "Bills Accepted",
  "Bills Quality failed",
];

const toNumber = (value) => {
  const parsed = parseFloat(value);
  return Number.isNaN(parsed) ? 0 : parsed;
};

const hasValue = (value) =>
  value !== null && value !== undefined && String(value).trim() !== "";

export const calculateNetPayable = (transaction = {}) => {
  if (hasValue(transaction.net_payable)) {
    return toNumber(transaction.net_payable);
  }

  const amount = toNumber(transaction.amount);
  const otherDeductions = toNumber(transaction.other_deductions);
  const tdsApplicable = transaction.tds_applicable;
  const tdsType = transaction.tds_type;
  const tdsValue = toNumber(transaction.tds_value);

  let netPayable = amount - otherDeductions;

  if (tdsApplicable === "yes") {
    if (tdsType === "percentage") {
      netPayable -= (amount * tdsValue) / 100;
    } else {
      netPayable -= tdsValue;
    }
  }

  return Number.isNaN(netPayable) ? 0 : parseFloat(netPayable.toFixed(2));
};

export const getPendingAmount = (transaction = {}) => {
  const paidAmount = toNumber(transaction.paidamount);

  if (paidAmount === 0 && FULLY_PAID_STATUSES.includes(transaction.status)) {
    return 0;
  }

  const pending = calculateNetPayable(transaction) - paidAmount;
  return pending < 0 ? 0 : parseFloat(pending.toFixed(2));
};
